import React, { useState, useEffect } from "react";
import api from "../services/api";
import Dashboard from "../pages/Dashboard";
import KidsDashboard from "../pages/KidsDashboard";
import { getToken } from "../services/auth";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

export default function DashboardWrapper() {
  const [loading, setLoading] = useState(true);
  const [kidsEnabled, setKidsEnabled] = useState(false);
  const [userRole, setUserRole] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const token = getToken();
        if (!token) {
          navigate("/login");
          return;
        }
        const decoded = jwtDecode(token);
        setUserRole(decoded.role);

        // If user is admin, redirect to admin dashboard instead
        if (decoded.role === "admin") {
          navigate("/admin");
          return;
        }

        // Only query settings for student roles to know whether to load kid's experience
        if (decoded.role === "student") {
          const res = await api.get("/settings/kids_dashboard").catch(() => ({ data: { enabled: false } }));
          setKidsEnabled(res.data?.enabled === true);
        }
      } catch (err) {
        console.error("Dashboard wrapper fetch error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center dark:bg-slate-900">
        <div className="w-12 h-12 border-4 border-indigo-600/20 border-t-indigo-600 rounded-full animate-spin" />
      </div>
    );
  }

  // If the kids dashboard feature is activated globally AND user is a student, render KidsDashboard
  if (userRole === "student" && kidsEnabled) {
    return <KidsDashboard />;
  }

  // Otherwise return standard dashboard (for teachers, parents, or standard student profile)
  return <Dashboard />;
}
